export enum AssociationBrandingName {
  Flasha = 'flasha',
  Fpma = 'fpma',
}
